module.exports = __webpack_public_path__ + "static/media/filter_bc.fe3ebc98.png";